export const SQL_DATE_FORMAT = 'YYYY-MM-DD';

export const UTILIZATION_TYPE_FLIGHT = 'flight';
export const UTILIZATION_TYPE_MAINTENANCE = 'maintenance';

export const OBJECT_TYPE_AIRCRAFT_DEFECT = 'aircraft_defect';
export const OBJECT_TYPE_TECH_LOG = 'tech_log';

export const DATA_FIELD_TYPE_TEXT = 'text';
export const DATA_FIELD_TYPE_TEXTAREA = 'textarea';
export const DATA_FIELD_TYPE_NUMBER = 'number';
export const DATA_FIELD_TYPE_DATE = 'date';
export const DATA_FIELD_TYPE_DATETIME = 'datetime';
export const DATA_FIELD_TYPE_SINGLE_SELECT = 'single_select';
export const DATA_FIELD_TYPE_MULTIPLE_SELECT = 'multiple_select';
export const DATA_FIELD_TYPE_SWITCH = 'switch';

export const UTILIZATION_STATUS_SCHEDULED = 'scheduled';
export const UTILIZATION_STATUS_COMPLETED = 'done';
export const UTILIZATION_STATUS_CANCELED = 'cancelled';

export const UTILIZATION_TYPE_TITLES = {
	[UTILIZATION_TYPE_FLIGHT]: {
		text: 'FLIGHT',
		color: 'default'
	},
	[UTILIZATION_TYPE_MAINTENANCE]: {
		text: 'MAINTENANCE',
		color: '#108ee9'
	}
};
